import React, { useState } from 'react';
import LeadFormLuxury from './LeadFormLuxury';
import { trackCtaClick } from '../../../utils/gtm';

export const QUOTE_OPTIONS = [
  { id: 'monthly', title: 'Monthly bookkeeping' },
  { id: 'catchup', title: 'Catch-up on past months' },
  { id: 'switching', title: 'Switching from my accountant' },
  { id: 'unsure', title: 'Not sure yet' },
];

const TOTAL_STEPS = 2;

/**
 * "Get a fixed quote" card.
 * Step 1: pick what you need (one tap moves on). Step 2: the existing Web3Forms
 * lead form, with the selection sent as the `service` field.
 * Pass `presetService` to skip straight to step 2 (e.g. from a package card).
 */
const QuoteWizard = ({ formId, isModal = false, onCloseModal, presetService = null, titleId }) => {
  const [step, setStep] = useState(presetService ? 2 : 1);
  const [selected, setSelected] = useState(null);

  const selectedOption = QUOTE_OPTIONS.find((o) => o.id === selected);
  const chipLabel = presetService || (selectedOption ? selectedOption.title : '');
  const serviceLabel = presetService || `Bookkeeping: ${chipLabel}`;

  const handleSelect = (id) => {
    trackCtaClick(isModal ? 'modal_quote_continue' : 'hero_quote_continue');
    setSelected(id);
    setStep(2);
  };

  return (
    <div className="bk-quote">
      <div className="bk-quote-head">
        <h2 className="bk-quote-title" id={titleId}>
          Get a fixed quote for your bookkeeping
        </h2>
        <span className="bk-quote-step">
          Step {step} of {TOTAL_STEPS}
        </span>
      </div>

      <div className="bk-quote-rule" />

      {step === 1 ? (
        <>
          <p className="bk-quote-q" id={`${formId}-q`}>What do you need?</p>
          <div className="bk-quote-options" role="group" aria-labelledby={`${formId}-q`}>
            {QUOTE_OPTIONS.map((opt) => (
              <button
                key={opt.id}
                type="button"
                className="bk-quote-option gtm-cta-btn"
                id={`${formId}-option-${opt.id}`}
                data-gtm-id="quote-option"
                onClick={() => handleSelect(opt.id)}
              >
                {opt.title}
              </button>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="bk-quote-chosen">
            <span className="bk-quote-chosen-label">You need</span>
            <span className="bk-quote-chosen-value">{chipLabel}</span>
            {!presetService && (
              <button type="button" className="bk-quote-change" onClick={() => setStep(1)}>
                Change
              </button>
            )}
          </div>
          <LeadFormLuxury
            formId={formId}
            isModal={isModal}
            onCloseModal={onCloseModal}
            service={serviceLabel}
          />
        </>
      )}

      <div className="bk-quote-foot">
        <span>60 seconds</span>
        <span className="bk-quote-foot-sep" aria-hidden="true">·</span>
        <span>No obligation</span>
        <span className="bk-quote-foot-sep" aria-hidden="true">·</span>
        <span>Reply in 15 min</span>
      </div>
    </div>
  );
};

export default QuoteWizard;
